module.exports = __webpack_public_path__ + "img/txt.1abdfe35.png";